//
//
//
//
//
//
var GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

export default {
  name: 'ParagraphTitle',
  components: {
    GlobalRichText
  },
  props: {
    paragraph: {
      type: Array,
      required: true
    }
  }
};